import React from "react";
import { ChevronDownIcon, UserRoundIcon } from "lucide-react";
import { UserProfile } from "./calendarData";
type UserMonthFilterProps = {
  users: UserProfile[];
  value: string | null;
  onChange: (userId: string | null) => void;
};
export function UserMonthFilter({
  users,
  value,
  onChange
}: UserMonthFilterProps) {
  return <label className="block min-w-[220px]" data-id="element-129" data-mp="1kt6jwn7syyha">
      <span className="mb-1.5 flex items-center gap-1.5 text-xs font-semibold text-slate-500" data-id="element-130" data-mp="o3fgtzlg42zv">
        <UserRoundIcon size={14} data-id="element-131" data-mp="s510c3shjfj1" /> View calendar for
      </span>
      <span className="relative block" data-id="element-132" data-mp="s5aqbrdj5moq">
        <select value={value ?? "all"} onChange={event => onChange(event.target.value === "all" ? null : event.target.value)} className="w-full appearance-none rounded-xl border border-slate-300 bg-white py-2.5 pl-3 pr-9 text-sm font-semibold text-slate-800 outline-none transition focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20" data-id="element-133" data-mp="x4di4a4i1wer">
          <option value="all" data-id="element-134" data-mp="2dk6mquuedw7d">All team members</option>
          {users.map(user => <option key={user.id} value={user.id} data-id="element-135" data-mp="2ec42yybndnas">{user.name} · {user.team}</option>)}
        </select>
        <ChevronDownIcon size={16} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-500" data-id="element-136" data-mp="25ds3s7wpth6q" />
      </span>
    </label>;
}